// WindowLevelTool.js
import ContrastIcon from "@mui/icons-material/Contrast";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { useState } from "react";
import { Menu, MenuItem, IconButton, Box } from "@mui/material";
import { ToolGroupManager, WindowLevelTool } from "@cornerstonejs/tools";
import { applyWindowLevel } from "../context/viewportService";

export const WindowLevelToolConfig = {
  name: "LEVEL",
  tool: WindowLevelTool.toolName, 
  icon: <WindowLevelDropdown />,
};

function WindowLevelDropdown() {
  const [anchorEl, setAnchorEl] = useState(null);

 
  const handleToolActivate = (event) => {
    event.stopPropagation();

    const toolGroups = ToolGroupManager.getAllToolGroups(); 

    toolGroups.forEach((toolGroup) => {
      toolGroup.setToolActive(WindowLevelTool.toolName, {
        bindings: [{ mouseButton: 1 }],
      });
    });
    
  };

 
  const handleOpen = (event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

 
  const handleSelect = async (type) => {
    await applyWindowLevel(type);
    console.log(type,'type')
    const toolGroups = ToolGroupManager.getAllToolGroups(); 

    toolGroups.forEach((toolGroup) => {
      toolGroup.setToolConfiguration(WindowLevelTool.toolName, {
        preset: type,
      });
    });

    handleClose();
  };

  return (
    <>
      <Box display="flex" alignItems="center">
        <IconButton onClick={handleToolActivate} sx={{ color: "inherit" }}>
          <ContrastIcon />
        </IconButton>

        <IconButton onClick={handleOpen} size="small" sx={{ color: "inherit" }}>
          <ArrowDropDownIcon fontSize="small" />
        </IconButton>
      </Box>

      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
        <MenuItem onClick={() => handleSelect("softTissue")}>Soft Tissue</MenuItem>
        <MenuItem onClick={() => handleSelect("Bone")}>Bone</MenuItem>
        <MenuItem onClick={() => handleSelect("Lung")}>Lung</MenuItem>
        <MenuItem onClick={() => handleSelect("Liver")}>Liver</MenuItem>
        <MenuItem onClick={() => handleSelect("Brain")}>Brain</MenuItem>
        <MenuItem onClick={() => handleSelect("brainInfarct")}>
          Brain Infarct
        </MenuItem>
      </Menu>
    </>
  );
}